import { cva, type VariantProps } from "class-variance-authority";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "../../../../lib/utils/cn";
import { useModalCloseEffect } from "../../../../hooks/useModalCloseEffect";
import * as React from "react";

export const ModalVariants = cva(
  "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-lg w-auto flex flex-col",
  {
    variants: {
      variant: {},
      size: {
        default: "min-w-[468px] max-w-fit rounded h-[80%]",
        mobile: "w-full max-w-[calc(100%-40px)] mx-auto rounded h-[80%] ",
        fitheight:
          "w-full max-w-[468px] sm:w-[calc(100%-40px)] max-h-[80%] mx-auto rounded",
        full: "w-full h-full",
        dialog: "w-[305px] rounded-[15px] min-h-[194px]",
        semifull:
          "bottom-0 top-auto left-1/2 -translate-x-1/2 translate-y-0 w-full mx-auto h-[93%] rounded-t-[15px] overflow-hidden",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

interface Props
  extends React.ComponentProps<"div">, VariantProps<typeof ModalVariants> {
  enableOutsideClick?: boolean;
  children?: React.ReactNode;
  close: () => void;
}

export default function BaseModal({
  size,
  close,
  enableOutsideClick = true,
  className,
  children,
}: // ...props
Props) {
  const { wrapperRef, handleOutsideClick } = useModalCloseEffect({
    onClose: close,
    enableOutsideClick: enableOutsideClick,
  });

  return (
    <AnimatePresence>
      <motion.div
        ref={wrapperRef}
        onClick={handleOutsideClick}
        className="fixed inset-0 z-[9999] bg-black/40"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.05, ease: "easeOut" }}
          className={cn(ModalVariants({ size }), className)}
          onClick={(e) => e.stopPropagation()}
          // {...props}
        >
          {children}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
